import type { ReactNode } from 'react';

import styles from './Spinner.module.css';

interface SpinnerProps {
  label?: ReactNode;
}

// Индикатор загрузки с необязательной подписью.
export function Spinner({ label }: SpinnerProps): JSX.Element {
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden="true" />
      {label}
    </div>
  );
}
